import type { Tq2QuestionGroupProps } from "../models/tech-form-page.models";

export const Tq2BwtsDetailsGroup = ({ children }: Tq2QuestionGroupProps) => (
  <fieldset className="mb-6 rounded-md border p-4">
    <legend className="px-2 text-base font-semibold">Ballast water treatment system details</legend>
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">{children}</div>
  </fieldset>
);
